export default __webpack_public_path__ + "static/media/header.42aa10a1.svg";